import DrawerSimple from "ds/components/DrawerNew/Simple";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import { WebhooksIntegration } from "types/generated";
import FormFieldViewText from "components/FormFields/ViewText";
import FormFieldViewBoolean from "components/FormFields/ViewBoolean";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";

type WebhookDetailsDrawerProps = {
  webhook: WebhooksIntegration;
};

const WebhookDetailsDrawer = createDrawer(({ webhook }: WebhookDetailsDrawerProps) => {
  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="Endpoint" value={webhook.endpoint} />
        <FormFieldViewBoolean label="Enabled" value={webhook.enabled} />
        <FormFieldViewBoolean label="Retry on failure" value={webhook.retryOnFailure} />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showWebhookDetailsDrawer = createDrawerTrigger(WebhookDetailsDrawer);
